module.exports = "<p>calidad works!</p>\n"